import * as React from 'react';
import Grid from '@mui/material/Grid';


export default function BillingInformationComparison({ expected, actual }) {
 

    return (
        <React.Fragment>
            <Grid container>
      
                <Grid container item xs={6}>
                <b>Myynti</b>
    
                <Grid container item xs={12}>
       
                    {expected.map((x,i)=> {
                        return (
                            <>
                            <Grid item xs={6}>
                                {x.name}
                            </Grid>
                             <Grid item xs={6}>
                                {x.price}€
                             </Grid>
                             </>
                        )
                    })}
                             </Grid>
                </Grid>
                <Grid container item xs={6}>
                    <b>Osto</b>
                    <Grid container item xs={12}>
                {actual.map((x,i)=> {
                        return (
                            <>
                            <Grid item xs={6}>
                                {x.name}
                            </Grid>
                             <Grid item xs={6}>
                                {x.price}€
                             </Grid>
                             </>
                        )
                    })}
                         </Grid>
                </Grid>
            </Grid>
        </React.Fragment>
    );
}